export enum NotificationConditionType {
    GreaterThan = 0,
    LessThan = 1,
    EqualTo = 2,
}